import { render, staticRenderFns } from "./SymptomPrevent.vue?vue&type=template&id=1c4d9e9e&scoped=true&"
import script from "./SymptomPrevent.vue?vue&type=script&lang=js&"
export * from "./SymptomPrevent.vue?vue&type=script&lang=js&"
import style0 from "./SymptomPrevent.vue?vue&type=style&index=0&id=1c4d9e9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4d9e9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VContainer,VIcon,VSelect,VSpacer,VToolbar})
